import moment from 'moment'
import L from 'services/Localization'
import _ from 'lodash'

export default {
  id(guid) {
    if (guid !== undefined) {
      let formatted = guid.split('-')[0]
      return `# ${formatted}`
    }
    return ''
  },
  stripAdnTrimString(value) {
    // remove blank space caracters and trim value
    value = value.replace(/(\r\n|\n|\r)/gm, '')
    value = _.trim(value)
    return value
  },
  percent(amount) {
    return amount + ' %'
  },
  roundAndPercent(amount) {
    if (_.isNaN(amount) || _.isUndefined(amount)) {
      amount = 0
    }
    if (amount < 1) {
      amount = amount * 100
    }
    return _.round(amount, 1) + ' %'
  },
  date(date, format) {
    format = format || 'YY-MM-DD'

    if (date === undefined || date === null || date === '---') {
      return '---'
    }
    return moment.utc(date).format(format)
  },
  dateFromEpoch(epoch) {
    if (epoch === undefined || epoch === null) {
      return '---'
    }
    return moment.utc(epoch * 1000).toString()
  },
  dateForPicker(date) {
    return moment.utc(date).format('MM/DD/YYYY')
  },
  money(amount) {
    // http://stackoverflow.com/questions/25722876/is-there-a-way-to-get-the-decimal-and-thousands-separator-in-ecmascript-internat
    if (amount === undefined) {
      return ''
    }

    if (_.isString(amount)) {
      amount = _.toNumber(amount)
    }

    const abp = window.abp
    const wholeParthLength = 0
    const decimalLength = 2
    const decimalSep = (12345.6789).toLocaleString(abp.localization.currentCulture.name).match(/345(.*)67/)[1]
    const sectionDelimiter = (12345.6789).toLocaleString(abp.localization.currentCulture.name).match(/12(.*)345/)[1]
    const re = `\\d(?=(\\d{${wholeParthLength || 3}})+${decimalLength > 0 ? '\\D' : '$'})`
    const num = amount.toFixed(Math.max(0, ~~decimalLength))

    return (decimalSep ? num.replace('.', decimalSep) : num).replace(new RegExp(re, 'g'),
      `$&${sectionDelimiter || ','}`) + ' $'
  },
  repeatsType(type) {
    return L.localize(`RepeatsType_${type}`)
  }
}



// WEBPACK FOOTER //
// ./scripts/services/Format.js